let DTODAV02 = {
  // 後台用
  doQuery: "/api/DTODAV02/doQuery",
  doInsert:  "/api/DTODAV02/doInsert",
  doUpdate: "/api/DTODAV02/doUpdate",
  doDelete: "/api/DTODAV02/doDelete",
  doUpload: "/api/DTODAV02/doUpload",
  //前台用
  getActContent: "/api/DTODAV02/getActContent",
};

export default DTODAV02;
